import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Tooltip } from "reactstrap";
import { toast } from "react-toastify";
import "./index.css";
import api from "service/api";
import Loading from "components/Loading";

const PipelineOverviewGenerative = ({
  setFinishedEventsAmount,
  executionId,
}) => {
  const { id } = useParams();
  const [generative, setGenerativeStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tooltipOpenSucessful, setTooltipOpenSucessful] = useState(false);
  const [tooltipOpenFailure, setTooltipOpenFailure] = useState(false);
  const toggleTooltipSucessful = () =>
    setTooltipOpenSucessful(!tooltipOpenSucessful);
  const toggleTooltipFailure = () => setTooltipOpenFailure(!tooltipOpenFailure);

  const fetchPipelineGenerative = useCallback(async () => {
    setLoading(true);
    api
      .get(
        `/pipeline/${id}/generative-stats${executionId ? `?executionId=${executionId}` : ""}`,
      )
      .then((response) => response.data)
      .then((response) => {
        setGenerativeStats(response);
        setFinishedEventsAmount(response?.successful ?? 0);
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Houve um problema ao tentar recuperar os status de analise generativa do pipeline.",
        );
        return;
      });
    setLoading(false);
  }, [id, executionId]);
  useState(() => {
    fetchPipelineGenerative();
  }, [id]);
  return (
    <Card className="bg-secondary">
      <CardHeader className="bg-white border-0 custom-card-header">
        Analise generativa
      </CardHeader>
      <CardBody className="position-relative">
        {loading ? <Loading /> : ""}
        <dl className="grid grid-cols-2 gap-y-2 default-font-size">
          <dt className="font-semibold">
            Com sucesso{" "}
            <i
              className="fas fa-info-circle"
              id="generative-successful-label"
            />
            <Tooltip
              placement="right"
              isOpen={tooltipOpenSucessful}
              target="generative-successful-label"
              toggle={toggleTooltipSucessful}
            >
              <div style={{ margin: "0", padding: "0" }}>
                Número total de eventos que foram analisados com sucesso pelo
                provedor.
              </div>
            </Tooltip>
          </dt>
          <dd className="mb-3 item-description">
            {generative?.successful ?? "N/A"}
          </dd>
          <dt className="font-semibold">
            Com erro{" "}
            <i className="fas fa-info-circle" id="generative-error-label" />
            <Tooltip
              placement="right"
              isOpen={tooltipOpenFailure}
              target="generative-error-label"
              toggle={toggleTooltipFailure}
            >
              <div style={{ margin: "0", padding: "0" }}>
                Número total de eventos que apresentaram erros durante o
                processamento ou envio ao provedor.
              </div>
            </Tooltip>
          </dt>
          <dd className="mb-3 item-description">
            {generative?.failure ?? "N/A"}
          </dd>
        </dl>
      </CardBody>
    </Card>
  );
};
export default PipelineOverviewGenerative;
